<div *ngIf="data?.content" class="innerContainer">
  <div class="catalogHeader">
    <div class="catalogHeader__mainHeading">
      <vc-breadcrumb
        *ngIf="breadcrumb.length"
        [items]="breadcrumb"
        [isCatalogPage]="true"
        [isMobile]="isMobile"
      ></vc-breadcrumb>
      <span class="catalogHeader__mainTitle vc-title-m">
        {{ data.content.headline }}
      </span>
      <p *ngIf="data.content.intro" class="catalogHeader__description">{{ data.content.intro }}</p>
    </div>

    <div class="catalogHeader__edito vc-d-none vc-d-md-block"></div>

    <div *ngIf="data.content.carousel" class="brandCarousel">
      <div class="brandCarousel__innerWrapper">
        <vc-ref
          class="brandCarousel__item"
          *ngFor="let item of data.content.carousel | slice: 0:4"
          [resource]="item.url.path"
        >
          <vc-images
            class="brandCarousel__item__image"
            lazyOff="true"
            [width]="340"
            [height]="169"
            url="{{ item.picture.path }}"
            alt="{{ item.text }}"
          ></vc-images>
          <p class="brandCarousel__item__title">{{ item.text }}</p>
        </vc-ref>
      </div>
    </div>
  </div>
</div>

<div *ngIf="campaign" class="catalogHeader__campaign">
  <h1 class="catalogHeader__campaign__mainTitle vc-title-m innerContainer">{{ campaign?.title }}</h1>
  <article class="catalogHeader__campaign__article innerContainer">{{ campaign?.localizedDescription }}</article>
  <vc-images
    class="catalogHeader__campaign__image"
    [url]="'/edito_v2/' + campaign.banner"
    width="1500"
    height="450"
    [imgSrcSet]="[
      {width: '401', height: '120', descriptor: '401w'},
      {width: '768', height: '230', descriptor: '768w'},
      {width: '1024', height: '307', descriptor: '1024w'}
    ]"
    sizes="100vw"
    [alt]="campaign.title"
  ></vc-images>
</div>
